export default __webpack_public_path__ + "static/media/sidebar_staffs_gray.18942dff.svg";